// Import style lib
import styled from 'styled-components';

// Import colors
import colors from '../../utils/styles/colors';

// Styled Login page wrapper
export const LoginWrapper = styled.main`
    /* Appearance */
    background-color: ${colors.primaryBeige};

    /* Element disposition */
    flex-grow: 1;

    /* Content disposition */
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    /* Spacing */
    padding: 50px;

    /* Mobile setup */
    @media (max-width: 600px) {
        gap: 10px;

        padding: 10px;
    }
`;

// Styled Login session
export const LoginSection = styled.section`
    /* Appearance */
    background-color: white;
    border-radius: 10px;

    /* Content disposition */
    display: flex;
    flex-direction: column;
    align-items: center;

    /* Size */
    width: 90%;
    max-width: 1200px;

    /* Spacing */
    padding: 50px;
    gap: 30px;

    /* Visual effects */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.5);

    /* Mobile setup */
    @media (max-width: 600px) {
        width: 85vw;

        padding: 15px;

        gap: 7px;
    }
`;

// Styled connectiuon title
export const LoginTitle = styled.h1``;

// Styled Login form
export const LoginForm = styled.form`
    /* Content disposition */
    display: flex;
    flex-direction: column;
    align-items: center;
`;

// Styled Login field container
export const LoginFieldContainer = styled.div`
    /* Content disposition */
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 30px;

    margin: 5px;

    /* Mobile setup */
    @media (max-width: 600px) {
        flex-direction: column;
        gap: 5px;
    }
`;

// Styled Login label
export const LoginLabel = styled.label``;

// Styled Login input
export const LoginInput = styled.input`
    /* Appearance */
    border: 1px solid #ccc;
    border-radius: 15px;

    height: 25px;
    /* Spacing */
    padding: 0px 10px;
`;

// Styled Login button
export const LoginButton = styled.button`
    /* Appearance */
    background-color: ${colors.primaryBeige};
    border-radius: 10px;

    /* Content disposition */
    display: flex;
    align-items: center;
    justify-content: center;

    /* Spacing */
    margin-top: 15px;
    padding: 5px 10px;

    /* Visual effects */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.3);

    /* Events */
    cursor: pointer;
    &:hover {
        filter: brightness(1.2);
    }
`;
